import { useEffect, useState } from 'react';

/**
 * État réseau du navigateur.
 *
 * `navigator.onLine` ment volontiers : il dit « en ligne » dès qu'une interface réseau
 * existe, même sans accès à Internet — exactement le cas du wifi de la salle Courbet.
 * C'est pour cela que la file offline ne s'y fie pas pour décider d'abandonner une
 * entrée : elle attend le verdict du serveur. Ce hook ne sert qu'à l'affichage.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
